import React, { useState, useRef, useEffect } from "react";
import Bredcrum from "../../components/bredcrum";
import { Toast } from "primereact/toast";
import { MultiSelect } from "primereact/multiselect";
// import { Titlebar } from "../../components/fieldsComp";
import { useLocation, useNavigate } from "react-router";
import { freightServices } from "../../services/freightServices";
import { Titlebar, Searchbox, Label } from "../../components/fieldsComp";

function EditFreight() {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useRef(null);
  const [errors, setErrors] = useState({});
  const [selectedServices, setSelectedservice] = useState([]);
  const [bulkServices, setBulkservices] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    types: [],
    contact_person: "",
    email: "",
    phone: "",
    address: "",
  });

  useEffect(() => {
    if (location.state?.freight) {
      setFormData(location.state.freight);
      setSelectedservice(location.state.freight.types || []);
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.phone) newErrors.phone = "Phone number is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.address) newErrors.address = "Address is required";
    if (!formData.contact_person) newErrors.contact_person = "Contact Person is required";
    return newErrors;
  };

  const refs = {
    name: useRef(null),
    email: useRef(null),
    phone: useRef(null),
    address: useRef(null),
    contact_person: useRef(null),
  };

  const handlesubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) {
      const firstErrorKey = Object.keys(validationErrors)[0];
      if (refs[firstErrorKey]) {
        refs[firstErrorKey].current.focus();
      }
      return;
    }

    const updatedFormData = { ...formData, types: selectedServices };

    freightServices.updatefreight(updatedFormData).then((response) => {
      if (response.status === 200) {
        toast.current.show({ severity: "success", summary: "Freight", detail: "Freight updated successfully" });
      } else {
        toast.current.show({ severity: "error", summary: "Freight", detail: response.data.data });
      }
    }).catch(() => {
      toast.current.show({ severity: "error", summary: "Freight", detail: "Error occurred while updating." });
    });
  };

  const handleClose = () => {
    navigate(-1); // or navigate('/freight-list'); if you have a specific page
  };

  const services = [
    { name: "Road", code: "road" },
    { name: "Air", code: "air" },
    { name: "Sea", code: "sea" },
    { name: "Courier", code: "courier" },
    { name: 'Self Courier', code: 'self_courier'}
  ];


  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={"Freight Provider / Update Freight Provider"} divider={false} />
      <div className="row">
        {/* <Titlebar text={"Edit Freight"} /> */}
        <div className="col-md-12 mt-3">
          <div className="card ps-3 pe-3">
            <div className="card-body card-body-style">
              <form onSubmit={handlesubmit}>
                <div className="row mb-3">
                  <div className="col-md-6">
                    <Label name="Name" />
                    <input
                      type="text"
                      onChange={handleChange}
                      ref={refs.name}
                      className="form-control"
                      id="name"
                      name="name"
                      placeholder="Enter Name"
                      value={formData.name || ""}
                      required
                    />
                    {/* {errors.name && <span style={{ color: "red" }}>{errors.name}</span>} */}
                  </div>

                  <div className="col-md-6">
                     <Label name="Services Type" />
                    <MultiSelect
                      id="type"
                      value={selectedServices}
                      onChange={(e) => setSelectedservice(e.value)}
                      options={services}
                      optionLabel="name"
                      filter
                      placeholder="Select Services"
                      className="w-100"
                      display="chip"
                      required
                    />
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                    <Label name="Contact Person" />
                    <input
                      type="text"
                      onChange={handleChange}
                      ref={refs.contact_person}
                      className="form-control"
                      id="contact_person"
                      name="contact_person"
                      placeholder="Enter Contact Person"
                      value={formData.contact_person || ""}
                      required
                    />
                    {/* {errors.contact_person && <span style={{ color: "red" }}>{errors.contact_person}</span>} */}
                  </div>

                  <div className="col-md-6">
                    <Label name="Email" />
                    <input
                      type="email"
                      ref={refs.email}
                      className="form-control"
                      id="email"
                      name="email"
                      placeholder="Enter email"
                      onChange={handleChange}
                      value={formData.email || ""}
                      required
                    />
                    {/* {errors.email && <span style={{ color: "red" }}>{errors.email}</span>} */}
                  </div>
                </div>

                <div className="row mb-3">
                  <div className="col-md-6">
                     <Label name="Phone" />

                    <input
                      type="number"
                      placeholder="Enter Phone Number"
                      ref={refs.phone}
                      className="form-control"
                      id="phone"
                      name="phone"
                      onChange={handleChange}
                      value={formData.phone || ""}
                      required
                    />
                    {/* {errors.phone && <span style={{ color: "red" }}>{errors.phone}</span>} */}
                  </div>

                  <div className="col-md-6">
                    <Label name="Address" />
                    <textarea
                      className="form-control"
                      placeholder="Enter Address"
                      id="address"
                      name="address"
                      onChange={handleChange}
                      ref={refs.address}
                      value={formData.address || ""}
                      required
                    />
                    {/* {errors.address && <span style={{ color: "red" }}>{errors.address}</span>} */}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <button type="submit" className="btn color-white me-2 w-100 rounded custom-btn-br-color custom-btn-color">
                      Update
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button type="button" onClick={handleClose} className="btn color-white w-100 rounded custom-btn-color-secondary">
                      Close
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditFreight;
